module.exports = __webpack_public_path__ + "img/polygon.abffad3b.gif";